"use strict";

if (process.env.NODE_ENV === "production") {
  module.exports = require("./dist/rele/client.js");
} else {
  module.exports = require("./dist/dev/client.js");
}
